const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/59dfc951-b411-40b8-8d6f-2feb48798dd5/images/e16595fd740da9588e881243abf8e9ea4263d3eb3a7f0224765cbd457794731f.png"
          alt="Testimonial background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-brand-bg-dark/85" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center space-y-6">
        <p className="text-xs uppercase tracking-[0.3em] font-body font-semibold text-brand-gold">
          Testimonials
        </p>
        <h2 className="font-heading text-3xl md:text-5xl font-light tracking-tight text-brand-text-light">
          What Our Customers <span className="italic text-brand-gold">Say</span>
        </h2>
        <div className="w-16 h-[1px] bg-brand-gold mx-auto" />
        <p
          data-testid="testimonials-coming-soon"
          className="font-heading text-2xl md:text-3xl font-light italic text-brand-gold/70 pt-8"
        >
          Coming Soon
        </p>
        <p className="font-body text-sm text-brand-text-light/40 max-w-md mx-auto">
          We're gathering stories from our valued customers. Check back soon to
          hear what they have to say about Sartaj.
        </p>
      </div>
    </section>
  );
};

export default Testimonials;
